
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkTaskTabColumnEnum } from '../models/work-task-tab-column-enum';
import { WorkTaskTabSortEnum } from '../models/work-task-tab-sort-enum';
import { requiredBoolean } from './required-boolean.validator';

export function getCreateTaskTabDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    roletypeIds: new FormControl<Array<number> | undefined>([]),
    standardtaskIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
    columns: new FormControl<WorkTaskTabColumnEnum[]>([]),
    sortBy: new FormControl<WorkTaskTabSortEnum | undefined>(undefined, [Validators.required]),
    dueRequired: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    onlyInFocus: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    hideWhenEmpty: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    onlyOwnTasks: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    showOverdue: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
})
;
}
      